import styled from "styled-components"

export const Paragraph = styled.p`
  color: var(--clr-text-blue);
  font-family: var(--ff-primary);

  font-weight: 400;
  font-size: 1em;
  line-height: 24px;

  @media (min-width: 40em) {
    font-size: 1.125em;
    line-height: 27px;
    font-weight: 500;
  }
`
